<template>
  <div
    class="row full-width row justify-end q-col-gutter-x-sm"
    v-if="selectedOutcome"
  >
    <div style="display: inline-block" v-if="showAllOption">
      <div
        style="height: 64px; width: 64px; border-radius: 64px"
        class="row items-center justify-center"
        :class="{
          'bg-primary': selectedOutcome
            ? selectedOutcome.name == 'All'
              ? true
              : false
            : false,
          'shadow-8': selectedOutcome
            ? selectedOutcome.name == 'All'
              ? true
              : false
            : false,
        }"
      >
        <q-img
          v-ripple
          @click="selectOutcome(allOption)"
          src="/statics/outcomes/all-icon.svg"
          class="outcome-logo q-mx-auto"
          style="height: 50px; width: 50px; border-radius: 64px"
        >
        </q-img>
      </div>
    </div>
    <div class="col-shrink" v-if="showAllOption">
      <div style="height: 60px; width: 2px; background-color: #162c471a"></div>
    </div>
    <div
      style="display: inline-block"
      v-for="(outcome, i) in list"
      :key="i"
      :name="outcome.name"
    >
      <div
        style="height: 64px; width: 64px; border-radius: 64px"
        class="row items-center justify-center"
        :class="{
          'bg-primary': selectedOutcome
            ? selectedOutcome.name == outcome.name
              ? true
              : false
            : false,
          'shadow-8': selectedOutcome
            ? selectedOutcome.name == outcome.name
              ? true
              : false
            : false,
        }"
      >
        <q-img
          v-ripple
          @click="selectOutcome(outcome)"
          :src="getOutcomeImage(outcome)"
          class="outcome-logo q-mx-auto"
          style="height: 50px; width: 50px; border-radius: 64px"
        >
        </q-img>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { getOutcomeImage } from "@/functions/getOutcomeImage";
  export default {
    props: {
      showAllOption: {
        type: Boolean,
        default: false,
      },
      defaultAll: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapGetters({
        list: "outcomes/list",
      }),
    },
    mounted() {
      if (this.defaultAll) {
        this.selectOutcome(this.allOption);
      }
      this.$store.dispatch("outcomes/loadAll").then(() => {
        if (!this.defaultAll) {
          this.selectOutcome(this.list[0]);
          F;
        }
      });
    },
    data: () => ({
      selectedOutcome: null,
      allOption: {
        name: "All",
        primaryColor: "",
        secondaryColor: "",
        tertiaryColor: "",
      },
    }),
    methods: {
      getOutcomeImage: getOutcomeImage,
      selectOutcome(outcome) {
        this.selectedOutcome = { ...outcome };
        this.$emit("outcomeSelect", outcome);
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
